export default __webpack_public_path__ + "static/media/Logo6.f3d6a1ad.png";